import { setDependency } from './decorators';
import { normalizeFactoryDeps } from './dependencyDescriptor';
/**
 * Register dependencies on a class.
 *
 * @param registerTarget The target constructor
 * @param deps Dependencies
 * @param startIndex The start index of the dependencies. Default is 0. When you want to set dependencies on a class
 * that has custom parameters, you should set `startIndex` to the count of these custom parameters.
 */
export function setDependencies(registerTarget, deps, startIndex) {
    if (startIndex === void 0) { startIndex = 0; }
    var normalizedDescriptors = normalizeFactoryDeps(deps, startIndex);
    normalizedDescriptors.forEach(function (descriptor) {
        setDependency(registerTarget, descriptor.identifier, descriptor.paramIndex, descriptor.quantity, descriptor.lookUp);
    });
}
//# sourceMappingURL=dependencyDeclare.js.map